import { useEffect, useState } from "react";
import {
  Badge,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useStyles } from "./tasksFilter.styles";
import { asyncGetLatestFocusArea } from "../../../../../todos/actions/todoActions";
import { TasksFiltersIcon } from "../../../../../shared/icons/TasksFiltersIcon";
import { MobileFiltersModal } from "../mobile-filters-modal/mobile-filters-modal";
import { DropDown } from "../../../../../common/DropDown";

export const TasksFilter = ({
  debouncedHandleFilterChange,
  debouncedHandleSortChange,
  filters,
  setFilters,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(asyncGetLatestFocusArea());
  }, [dispatch]);

  const { latestFocusAreas } = useSelector((state) => ({
    latestFocusAreas: [...state.todosReducer.latestFocusAreas],
  }));

  const handleFiltersChange = (event) => {
    const { value, name } = event.target;
    setFilters({ ...filters, [name]: value });
    const valueToSet = value < 0 ? "all" : value;
    debouncedHandleFilterChange(valueToSet, name);
  };

  const handleSortChange = (event) => {
    const { value, name } = event.target;
    if (value !== "-1") {
      setFilters({ ...filters, [name]: value });
      const orderBy = value === "date" ? "dueDate" : "origin";
      debouncedHandleSortChange(orderBy, "asc");
    }
  };

  const [openFiltersModal, setOpenFiltersModal] = useState(false);
  const handleOpenFiltersModal = () => setOpenFiltersModal(true);
  const handleCloseFiltersModal = () => setOpenFiltersModal(false);

  const invisibleFiltersBadge = !!filters?.focusAreaId || !!filters?.sortBy;

  const displayTasksFilters = () => {
    if (small) {
      return (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <IconButton
            className={classes.filtersIcon}
            onClick={handleOpenFiltersModal}
          >
            <Badge
              color="primary"
              variant="dot"
              invisible={!invisibleFiltersBadge}
            >
              <TasksFiltersIcon />
            </Badge>
          </IconButton>
        </Grid>
      );
    }
    return (
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        className={classes.filterContainer}
      >
        <div className={classes.formControl}>
          <DropDown
            data={[
              { id: -1, text: "Focus area" },
              { id: -2, text: "All" },
              ...latestFocusAreas.map(({ name, focusAreaId }) => ({
                text: name,
                id: focusAreaId,
              })),
            ]}
            onChange={handleFiltersChange}
            state={filters?.focusAreaId.toString()}
            name="focusAreaId"
          />
        </div>

        <div className={classes.formControl}>
          <DropDown
            data={[
              { id: "-1", text: "Sort By" },
              { id: "type", text: "Type" },
              { id: "date", text: "Date" },
            ]}
            onChange={handleSortChange}
            state={filters?.sortBy}
            name="sortBy"
          />
        </div>
      </Grid>
    );
  };

  return (
    <>
      <MobileFiltersModal
        open={openFiltersModal}
        handleClose={handleCloseFiltersModal}
        focusAreas={latestFocusAreas}
        filters={filters}
        setFilters={setFilters}
        debouncedHandleFilterChange={debouncedHandleFilterChange}
        debouncedHandleSortChange={debouncedHandleSortChange}
      />
      {displayTasksFilters()}
    </>
  );
};

TasksFilter.propTypes = {
  debouncedHandleFilterChange: PropTypes.func.isRequired,
  debouncedHandleSortChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    sortBy: PropTypes.string.isRequired,
    focusAreaId: PropTypes.number.isRequired,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
